/**
 * ZbSummary — ZeroBounce results chips shown on delivery cards.
 *
 * Props:
 *   zbResults — { total, by_status: { [status]: count }, ... }
 *   checkedAt — ISO datetime string (optional)
 */

// ZeroBounce status → display color
export const ZB_STATUS_COLORS = {
  'Valid':     '#27ae60', 'Invalid':   '#e74c3c', 'Catch-All': '#f39c12',
  'Unknown':   '#95a5a6', 'Spamtrap':  '#e74c3c', 'Abuse':     '#e67e22',
  'DoNotMail': '#e67e22',
  valid: '#27ae60', invalid: '#e74c3c', error: '#e74c3c', skipped: '#bdc3c7',
};

/** Format a UTC datetime string for display in America/New_York. */
export function fmtDate(d) {
  if (!d) return '—';
  // Backend sends UTC datetimes without Z — append Z so JS parses as UTC, not
  // local. One that already carries an offset ('+00:00', e.g. a check report's
  // checked_at) keeps it; appending Z there made it unparseable (2026-10-23).
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/.test(d);
  const iso = d.includes('T') || d.includes(' ')
    ? (hasZone ? d.replace(' ', 'T') : `${d.replace(' ', 'T')}Z`)
    : d; // date-only strings: leave as-is
  const dt = new Date(iso);
  if (isNaN(dt)) return d;
  // A date-only string parses as UTC midnight, so it renders in UTC too —
  // in New York time '2026-10-24' read as Oct 23.
  const opts = { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' };
  if (d.includes('T') || d.includes(' ')) {
    opts.timeZone = 'America/New_York';
    opts.hour = 'numeric';
    opts.minute = '2-digit';
    opts.timeZoneName = 'short';
  }
  return dt.toLocaleString('en-US', opts);
}

export default function ZbSummary({ zbResults, checkedAt }) {
  if (!zbResults || !zbResults.by_status) return null;
  const { by_status, total } = zbResults;
  return (
    <div style={{ marginTop: '8px', padding: '6px 10px', background: '#f8f9fa', borderRadius: '6px', border: '1px solid #e0e4e8' }}>
      <div style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
        <strong>📧 ZeroBounce</strong> — {total} email{total !== 1 ? 's' : ''} verified
        {checkedAt && <span style={{ color: '#aaa', marginLeft: '6px' }}>{fmtDate(checkedAt)}</span>}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
        {Object.entries(by_status).map(([status, count]) => (
          <span key={status} style={{
            background: 'white', border: `1px solid ${ZB_STATUS_COLORS[status] || '#ccc'}`,
            borderRadius: '4px', padding: '1px 7px', fontSize: '11px',
            color: ZB_STATUS_COLORS[status] || '#555',
          }}>
            {status}: <strong>{count}</strong>
          </span>
        ))}
      </div>
    </div>
  );
}
